function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#ED1C24;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#D0C0A3;}\r\n\t.st3{fill:#C0AC95;}\r\n\t.st4{fill:#E0D4B9;}\r\n\t.st5{fill:#C6B29E;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M166.87,137.56H80l-57.85,66.15v313.33h202.69V203.86L166.87,137.56z M123.5,186.14 c-8.52,0-15.43-6.91-15.43-15.43s6.91-15.43,15.43-15.43s15.43,6.91,15.43,15.43C138.93,179.23,132.02,186.14,123.5,186.14z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M123.5,150.71c-11.05,0-20,8.95-20.01,20c0,11.05,8.95,20,20.01,20c11.05,0,20-8.95,20-20 S134.55,150.71,123.5,150.71z M123.5,181.57c-6-0.01-10.85-4.86-10.86-10.86c0.01-6,4.86-10.85,10.86-10.86 c6,0.01,10.85,4.86,10.86,10.86C134.35,176.7,129.5,181.56,123.5,181.57z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M122.97,119.18c0-7.93-0.43-15.96-1.81-24.28c-3.82-22.84-12.18-40.58-12.14-60.13 c0-8.13,1.4-16.62,5.15-26.09c0.46-1.17-0.11-2.5-1.28-2.97c-1.17-0.47-2.5,0.11-2.97,1.28c-3.96,9.98-5.47,19.12-5.47,27.78 c0.04,20.9,8.58,38.79,12.2,60.88c1.32,8.01,1.74,15.77,1.74,23.53c0,13.14-1.21,26.27-1.22,40.37c0,0.87,0,1.74,0.02,2.62 c0.01,1.25,1.03,2.26,2.29,2.26h0.02c1.26-0.01,2.27-1.05,2.26-2.31l0,0c-0.01-0.86-0.02-1.71-0.02-2.56 C121.75,145.72,122.96,132.6,122.97,119.18z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M109.48,27.07l-4.97,4.97c-0.01,0.39-0.02,0.78-0.03,1.17l4.84-4.84C109.37,27.93,109.43,27.5,109.48,27.07 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M110.65,20.11l-5.62,5.62c-0.05,0.43-0.1,0.86-0.15,1.29l5.45-5.45C110.43,21.08,110.54,20.59,110.65,20.11 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M112.93,12.04l-6.65,6.65c-0.11,0.49-0.21,0.97-0.31,1.46l6.42-6.42 C112.56,13.16,112.73,12.61,112.93,12.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M113.27,5.9l-4.68,4.68c-0.2,0.57-0.36,1.12-0.54,1.69l5.81-5.81C113.7,6.24,113.51,6.05,113.27,5.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M109.06,33.28l-4.52,4.52c0.02,0.37,0.02,0.74,0.04,1.1l4.46-4.46C109.03,34.06,109.05,33.67,109.06,33.28z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M109.15,38.98l-4.23,4.23c0.04,0.34,0.08,0.68,0.12,1.02l4.18-4.19C109.21,39.69,109.17,39.33,109.15,38.98 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M109.64,44.28l-4.04,4.04c0.05,0.33,0.1,0.66,0.15,0.99l4-4C109.72,44.96,109.68,44.62,109.64,44.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M110.39,49.32l-3.91,3.91c0.06,0.32,0.13,0.63,0.19,0.95l3.9-3.9C110.51,49.96,110.45,49.64,110.39,49.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M111.35,54.15l-3.83,3.83c0.07,0.31,0.15,0.62,0.22,0.92l3.82-3.82C111.49,54.77,111.42,54.46,111.35,54.15 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M112.44,58.85l-3.78,3.78c0.08,0.3,0.15,0.61,0.23,0.91l3.77-3.77C112.59,59.47,112.52,59.16,112.44,58.85z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M113.61,63.47l-3.74,3.74c0.08,0.3,0.16,0.6,0.24,0.9l3.74-3.74C113.77,64.07,113.69,63.77,113.61,63.47z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M114.83,68.04l-3.73,3.73c0.08,0.3,0.16,0.6,0.24,0.9l3.73-3.73C115,68.64,114.92,68.34,114.83,68.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M116.07,72.6l-3.73,3.73c0.08,0.3,0.16,0.6,0.24,0.91l3.74-3.74C116.23,73.2,116.15,72.9,116.07,72.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M117.28,77.18l-3.76,3.76c0.08,0.3,0.15,0.61,0.23,0.92l3.76-3.76C117.43,77.79,117.35,77.49,117.28,77.18z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M118.44,81.81l-3.8,3.8c0.07,0.31,0.14,0.62,0.21,0.93l3.81-3.81C118.59,82.42,118.51,82.12,118.44,81.81z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M119.53,86.51l-3.86,3.86c0.06,0.32,0.13,0.63,0.2,0.95l3.86-3.86C119.66,87.14,119.6,86.82,119.53,86.51z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M120.51,91.32l-3.93,3.93c0.02,0.13,0.05,0.26,0.07,0.39c0.03,0.2,0.06,0.4,0.09,0.59l3.95-3.95 C120.63,91.97,120.57,91.64,120.51,91.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M121.37,96.26l-4.05,4.05c0.04,0.34,0.09,0.68,0.13,1.02l4.07-4.07C121.47,96.92,121.42,96.59,121.37,96.26 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.05,101.36l-4.19,4.19c0.03,0.35,0.06,0.71,0.08,1.06l4.21-4.21 C122.12,102.05,122.09,101.71,122.05,101.36z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.54,106.67l-4.32,4.32c0.02,0.37,0.03,0.73,0.04,1.1l4.35-4.35 C122.59,107.38,122.56,107.03,122.54,106.67z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.84,112.16l-4.46,4.46c0,0.38,0.01,0.76,0.01,1.14l4.5-4.49C122.87,112.9,122.85,112.53,122.84,112.16z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.96,117.83l-4.6,4.6c0,0.38,0,0.77-0.01,1.16l4.62-4.62C122.96,118.59,122.96,118.21,122.96,117.83z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.92,123.66l-4.69,4.69c-0.01,0.39-0.02,0.79-0.04,1.18l4.71-4.71 C122.9,124.44,122.91,124.05,122.92,123.66z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.76,129.61l-4.76,4.76c-0.02,0.4-0.04,0.8-0.05,1.2l4.77-4.77 C122.73,130.41,122.74,130.01,122.76,129.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.51,135.65l-4.79,4.79c-0.02,0.4-0.04,0.8-0.05,1.2l4.79-4.79 C122.48,136.45,122.5,136.05,122.51,135.65z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122.24,141.71l-4.77,4.77c-0.02,0.4-0.03,0.79-0.04,1.19l4.77-4.77 C122.21,142.51,122.23,142.11,122.24,141.71z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M122,147.75l-4.72,4.72c-0.01,0.39-0.02,0.78-0.03,1.17l4.7-4.7C121.97,148.54,121.98,148.14,122,147.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M121.82,153.72l-4.63,4.63c0,0.39-0.01,0.77-0.01,1.16l4.62-4.62C121.8,154.5,121.81,154.11,121.82,153.72z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M121.75,159.58l-4.02,4.02c0.18,0.21,0.39,0.38,0.62,0.52l3.4-3.4 C121.75,160.34,121.75,159.96,121.75,159.58z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M138.32,6.19c-1.11-0.6-2.5-0.18-3.09,0.93c-9.06,16.83-11.31,38.16-11.33,60.61 c0,24.76,2.8,50.95,2.79,73.93c0,7.21-0.27,14.1-0.98,20.51c-0.14,1.26,0.76,2.39,2.02,2.52c0.09,0.01,0.17,0.02,0.26,0.02 c1.15,0,2.14-0.87,2.27-2.04c0.73-6.64,1.01-13.69,1.01-21.01c0-23.33-2.8-49.5-2.79-73.93c-0.01-22.15,2.32-42.79,10.78-58.44 C139.84,8.18,139.43,6.79,138.32,6.19z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M127.04,30.65l6.21-6.21c0.15-0.54,0.31-1.08,0.47-1.62l-6.37,6.37C127.25,29.68,127.14,30.16,127.04,30.65 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M128.91,22.99l7.34-7.34c0.28-0.69,0.58-1.36,0.88-2.03l-7.75,7.74C129.22,21.91,129.07,22.45,128.91,22.99 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M131.92,14.19l7.23-7.23c-0.14-0.23-0.33-0.43-0.55-0.59l-5.82,5.82 C132.48,12.86,132.19,13.52,131.92,14.19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M125.81,37.67l5.61-5.61c0.1-0.49,0.21-0.97,0.31-1.46l-5.71,5.71C125.94,36.77,125.88,37.22,125.81,37.67z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.98,44.3l5.25-5.25c0.06-0.45,0.13-0.9,0.2-1.35l-5.33,5.33C125.06,43.44,125.02,43.87,124.98,44.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.43,50.63l5.01-5.01c0.04-0.42,0.08-0.85,0.13-1.27l-5.04,5.04C124.5,49.81,124.46,50.22,124.43,50.63z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.11,56.75l4.82-4.82c0.03-0.41,0.06-0.82,0.08-1.23l-4.86,4.86C124.14,55.95,124.13,56.35,124.11,56.75 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M123.94,62.71l4.69-4.69c0.01-0.4,0.03-0.79,0.04-1.19l-4.71,4.71C123.96,61.93,123.95,62.32,123.94,62.71z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M123.89,67.72c0,0.27,0,0.54,0.01,0.81l4.59-4.59c0-0.39,0.01-0.77,0.02-1.16l-4.61,4.61 C123.9,67.51,123.89,67.62,123.89,67.72z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M123.96,74.27l4.52-4.52c0-0.38-0.01-0.76-0.01-1.14l-4.53,4.53C123.95,73.52,123.95,73.9,123.96,74.27z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.1,79.92l4.46-4.46c-0.01-0.38-0.02-0.75-0.02-1.12l-4.47,4.47C124.08,79.18,124.09,79.55,124.1,79.92z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.3,85.52l4.41-4.41c-0.01-0.37-0.02-0.74-0.03-1.11l-4.42,4.42C124.27,84.78,124.28,85.15,124.3,85.52z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.54,91.07l4.38-4.38c-0.02-0.37-0.03-0.73-0.04-1.1l-4.38,4.38C124.51,90.34,124.52,90.7,124.54,91.07z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.81,96.58l4.36-4.36c-0.02-0.36-0.04-0.73-0.05-1.09l-4.36,4.36C124.78,95.86,124.8,96.22,124.81,96.58 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M125.11,102.08l4.34-4.34c-0.02-0.36-0.04-0.72-0.06-1.08l-4.34,4.35 C125.07,101.35,125.09,101.71,125.11,102.08z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M125.42,107.56l4.34-4.34c-0.02-0.36-0.04-0.72-0.06-1.08l-4.34,4.34 C125.38,106.84,125.4,107.2,125.42,107.56z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M125.72,113.05l4.34-4.34c-0.02-0.36-0.04-0.72-0.06-1.08l-4.34,4.34 C125.68,112.33,125.7,112.69,125.72,113.05z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126,118.56l4.36-4.36c-0.02-0.36-0.04-0.72-0.06-1.08l-4.35,4.35C125.97,117.83,125.99,118.2,126,118.56z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.26,124.09l4.38-4.38c-0.02-0.36-0.03-0.73-0.05-1.09l-4.37,4.37 C126.23,123.36,126.25,123.73,126.26,124.09z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.47,129.67l4.41-4.41c-0.02-0.37-0.03-0.73-0.04-1.1l-4.4,4.4 C126.45,128.94,126.46,129.3,126.47,129.67z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.62,135.32l4.46-4.46c-0.01-0.37-0.02-0.74-0.03-1.11l-4.45,4.45 C126.6,134.57,126.61,134.94,126.62,135.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.68,141.04l4.53-4.53c-0.01-0.37-0.02-0.75-0.02-1.12l-4.51,4.51 C126.68,140.29,126.68,140.67,126.68,141.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.63,146.88l4.62-4.62c0-0.21,0.01-0.41,0.01-0.61c0-0.18,0-0.35,0-0.53l-4.61,4.61 C126.64,146.11,126.64,146.5,126.63,146.88z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.42,152.89l4.75-4.75c0.01-0.4,0.03-0.78,0.04-1.18l-4.73,4.73 C126.46,152.09,126.44,152.49,126.42,152.89z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M125.99,159.11l4.94-4.94c0.02-0.41,0.05-0.81,0.07-1.22l-4.89,4.89 C126.07,158.28,126.02,158.69,125.99,159.11z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M126.64,164.25l3.82-3.82c0.04-0.42,0.08-0.84,0.12-1.26l-4.49,4.49 C126.23,163.89,126.42,164.09,126.64,164.25z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M117.69,137.56c0.18-0.14,0.38-0.28,0.59-0.41c1.5-0.93,3.8-1.59,6.38-1.59c2.58-0.01,4.88,0.66,6.38,1.59 c0.22,0.14,0.41,0.27,0.59,0.41h5.94c-0.71-1.74-2.12-3.2-3.81-4.23c-2.47-1.5-5.64-2.34-9.11-2.35 c-3.47,0.01-6.64,0.85-9.11,2.35c-1.7,1.03-3.1,2.48-3.81,4.23H117.69z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M113.35,135.12l2.63,2.44h1.23l-3.25-3.01C113.75,134.74,113.54,134.92,113.35,135.12z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M116.9,132.63l3.77,3.49c0.31-0.09,0.63-0.18,0.97-0.25l-3.9-3.62C117.45,132.37,117.18,132.5,116.9,132.63 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M121.64,131.22l4.8,4.44c0.53,0.06,1.04,0.16,1.53,0.27l-5.23-4.85C122.36,131.12,122,131.17,121.64,131.22 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M127.93,131.26l6.8,6.3h1.24l-6.46-5.98C129,131.45,128.47,131.35,127.93,131.26z"
}))));

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "tag-svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247 530.64",
    style: {
      enableBackground: "new 0 0 247 530.64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 123.495,
    cy: 140.71,
    r: 20.0025,
    gradientTransform: "matrix(1 0 0 1 0 30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#941B16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2059,
    style: {
      stopColor: "#8F1814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#83110B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#6F0100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#6C0000"
    }
  })), _ref4), _ref5));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.e087d15a.svg";
export { ForwardRef as ReactComponent };